import { Server, Model, RestSerializer } from 'miragejs'

import event from './factories/event'
import image from './factories/image'
import installation from './factories/installation'
import menu from './factories/menu'

import seeds from './seeds'
import routes from './routes'

const ApplicationSerializer = RestSerializer.extend({
  root: false,
  embed: true
})

export function startMirage(environment = 'development') {
  return new Server({
    environment,
    trackRequests: environment === 'test',

    models: {
      event: Model,
      image: Model,
      installation: Model,
      menu: Model
    },

    factories: {
      event,
      image,
      installation,
      menu
    },

    seeds,
    routes,

    serializers: {
      application: ApplicationSerializer
    }
  })
}
